// extracted by mini-css-extract-plugin
export default {"button":"sQ1HV","secondary":"_5ynne","disabled":"clS76","wrapper":"TnoOZ","secondaryButton":"BKj-V","primaryButton":"kxCDW"};